import { render, staticRenderFns } from "./changeTPwd.vue?vue&type=template&id=52e4cebb"
import script from "./changeTPwd.vue?vue&type=script&lang=js"
export * from "./changeTPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports